import { renderCatch } from '../../../app-core/lib/error/renderCatch'
import { Base_commonDeps } from '../Base/Base.commonDeps'
import { Base_Component } from '../Base/Base.ui.Component'

/**
 * Inject on page load to avoid circular dependencies
 */
export function Erro_injectRenderCatchIntoBaseComponent() {
    Base_Component.prototype.renderCatch = (tryRender) => renderCatch(Base_commonDeps(), tryRender)
}
